<template>
  <div >
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 mb-base" >
        <vx-card  slot="no-body" :title="$t('CashFlow.Template.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(roles.writers)">
          <menu-control :items="templateItems">
          </menu-control>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>

import roles from './../roles.js'
import pages from './../pages.js'
import menuControl from '@/app/shared/components/lists/menu.vue'
import { odtHostname } from '@/environment/environment'

const cashFlowPages = new pages();

export default {
  components: {
    menuControl
  },
  mounted() {
    window.location.href = odtHostname + "/bsg/";
  },
  data () {
    return {
      roles,
      templateItems : cashFlowPages.getTemplateItems()
    }
  }
}
</script>